import classes from "./SelectInput.module.scss";
import { ChangeEventHandler, PropsWithChildren } from "react";

type IProps = PropsWithChildren<{
  label?: string;
  onChange: ChangeEventHandler<HTMLSelectElement>;
}>;

export const SelectInput = ({ label, onChange, children }: IProps) => {
  return (
    <div>
      { label && <label className={classes.Label}>{label}</label> }

      <select
        className={classes.Select}
        onChange={onChange}
      >
        {children}
      </select>
    </div>
  );
};
